import { ICellRendererParams } from "ag-grid-community";
import { useMemo } from "react";
import { IPendingListRow } from "../../../../../api/services";
import CircleAvailabilities from "../../../../../components/circle-availability/CircleAvailability";

const CellAvailability = (params: ICellRendererParams<IPendingListRow>) => {
    const cars = useMemo<number>(() => params.data?.booking.pendingAvailability ?? 0, []);
    return (
        <CircleAvailabilities availableCars={cars} />
    );
}

export default CellAvailability;